import { Atom, Cmp, state } from ":mods";
import { For, Show, createEffect, createMemo, createSignal, splitProps, untrack } from "solid-js";
import { ASubmoduleMaterial } from "../../../../models";

type SidebarProps = {
  elements: {
    data: ASubmoduleMaterial<3>;
  };
  events: {
    onAddNewCollection: () => void;
    onGetCollection: (collectionID: number | string) => void;
    onDeleteCollection: (collectionID: number | string) => void;
  };
};

const design_name_to_obj_map = {
  tp07_task01: {
    name: "Persona",
    btn_name: "Add Object",
  },
  tp17_task01: {
    name: "Int. Plan",
    btn_name: "Add interpretation",
  },
  tp16_task01: {
    name: "Object",
    btn_name: "Add Object",
  },
  tp22_task01: {
    name: undefined,
    btn_name: "Add Object",
  },
};
function getManySubmissions(design_name: string) {
  const multi_card_name = design_name_to_obj_map[design_name];
  if (!multi_card_name) {
    return undefined;
  }
  return multi_card_name as (typeof design_name_to_obj_map)[keyof typeof design_name_to_obj_map];
}

export function SideTaskBar(props: SidebarProps) {
  const design_name = props.elements.data.design_name;
  const $loading = state.create(undefined as { id: number; msg: string });
  const $active_id = createMemo(() => props.elements.data.collection?.active_id ?? -1);
  const $conditions = createMemo(() => {
    const max_elements = props.elements.data?.max_elements;
    const items_length = props.elements.data?.collection?.items.length;
    const more_than_one_item_exist = props.elements.data?.collection?.items?.length > 1;
    const fill_form = $active_id() < 0;
    const is_tp22 = design_name.startsWith("tp22");
    untrack(() => {
      // console.log("items length :: ", items_length, " :: ", $loading.value);
    });
    return {
      is_tp22,
      max_elements,
      items_length,
      more_than_one_item_exist,
      fill_form,
      btn_add_active: is_tp22 ? false : items_length >= max_elements || fill_form ? false : true,
      btn_delete_active: is_tp22 ? false : more_than_one_item_exist ? true : false,
    };
  });

  const $collection_items = createMemo(() => {
    const items = props.elements.data.collection?.items;
    const tp22_items = props.elements.data.collection?.material_related_objects;
    $loading.set(undefined);
    if (tp22_items) {
      const result = [undefined, undefined, undefined];
      for (const tp22_item of tp22_items) {
        const obj = {
          id: tp22_item.id,
          name: tp22_item.name?.split("|")?.[1].trim().toLowerCase() ?? "UNNAMED ITEM",
        };
        if (obj.name === "start") result[0] = obj;
        if (obj.name === "middle") result[1] = obj;
        if (obj.name === "end") result[2] = obj;
      }
      return result;
    }
    if (!items || items.length <= 0) {
      return [
        {
          id: -1,
          name: undefined,
        },
      ];
    }
    if (items[items.length - 1].id < 0) {
      return items;
    }
    return items.reverse();
  });

  const many_submissions = getManySubmissions(props.elements.data.design_name);
  const disabled_class = "!cursor-not-allowed opacity-70";

  function onAction(action: "add" | "get" | "delete", id: number) {
    if (action === "add") {
      // $loading_msg.set("Adding Item");
      // console.log("adding item");
      props.events.onAddNewCollection?.();
    } else if (action === "get") {
      $loading.set({ id, msg: "Loading Item" });
      props.events.onGetCollection?.(id);
    } else if (action === "delete") {
      $loading.set({ id, msg: "Deleting Item" });
      props.events.onDeleteCollection?.(id);
    }
  }
  return (
    <main class="w-full h-full ">
      {props.elements.data.design_name !== "tp01_task01" && <div class="w-full h-3px bg#nav-side-divider" />}
      <h1 class="px-2 py-1 ">{"Topic"} </h1>

      <h1 class="p-2 font-400 text-18px">
        {props.elements.data.design_name.split("_")[1].replace("task", "Task ") +
          " - " +
          props.elements.data.name.split("|")[0]}
      </h1>

      {/* #BDD2EA */}
      <div class="w-full h-3px bg#nav-side-divider" />

      <Show when={many_submissions}>
        <section class="relative flex flex-col w-full">
          {/* <Show when={$loading_msg.value}>
            <div class="absolute flex flex-col text-white bg-black/30 w-full h-full !z-10 items-center justify-center">
              <Atom.Loader.Platform
                title={$loading_msg.value}
                msg=""
                class="relative flex$col extend$ fight$ cursor-wait"
              />
            </div>
          </Show> */}
          {/* button */}
          <div class="flex flex-row self-end my-3 space-x-2">
            <Atom.Buttons.ButtonNoAnchor
              text="Delete Item"
              theme="dark"
              cls={`w-fit bg-red-500 ${!$conditions().btn_delete_active ? disabled_class : ""}`}
              onClick={() => {
                if (!$conditions().btn_delete_active) {
                  return;
                }
                onAction("delete", $active_id());
              }}
            />
            <Atom.Buttons.ButtonNoAnchor
              text={!$conditions().fill_form ? many_submissions.btn_name : "Fill Form To Add More"}
              theme="dark"
              cls={`w-fit ${!$conditions().btn_add_active ? disabled_class : ""}`}
              onClick={() => {
                if (!$conditions().btn_add_active) {
                  return;
                }
                onAction("add", $active_id());
                //
              }}
            />
          </div>
          {/* list */}
          <For each={$collection_items()}>
            {(item, index) => {
              const $focused = createMemo(() =>
                $conditions().is_tp22 ? item.id === props.elements.data.id : item.id === $active_id()
              );
              return (
                <div class="relative w-98% hover:(drop-shadow-black drop-shadow-lg) transition-all duration-300 ease-in-out">
                  {/* {props.elements.data.design_name === "tp22_task01" || $collection_items().length <= 1 ? null : (
                    <i
                      class="icon-local:delete-black w-24px h-24px  absolute top-3px right-0 cursor-pointer z-5"
                      //  onClick={onDeleteBox}
                    />
                  )} */}
                  <div
                    id={item.id.toString()}
                    onClick={() => {
                      if ($active_id() === item.id || $loading.unwrap !== undefined) {
                        return;
                      }
                      onAction("get", item.id);
                    }}
                    class={`
                    flex gap-1 px-2 items-center py-1 w-full m-1 bg#n-50 rounded-sm cursor-pointer border-2 border-solid
                    ${$focused() ? ` border#p` : `border#n-50 border-solid`}
                    ${$loading.value ? "!cursor-not-allowed opacity-70" : ""}
                    `}
                  >
                    <div>
                      {props.elements.data.design_name === "tp07_task01" ? (
                        <div class="icon-local-material-tasks:persona-icon w-24px h-24px"></div>
                      ) : props.elements.data.design_name === "tp17_task01" ? (
                        <div class="icon-local-material-tasks:plan-icon w-24px h-24px"></div>
                      ) : (
                        <div class="icon-local-material-tasks:object-icon w-24px h-24px"></div>
                      )}
                    </div>
                    <div class="relative flex flex-col w-full py-2">
                      <h4 class={`relative font-700 capitalize`}>
                        <Show when={props.elements.data.design_name !== "tp22_task01"} fallback={item.name}>
                          {many_submissions.name} {index() + 1}
                        </Show>
                      </h4>
                      {props.elements.data.design_name !== "tp22_task01" && (
                        <h5 class="font-400 py-1">{item.title ?? item.name}</h5>
                      )}
                      <Show when={$loading.value && $loading.value.id === item.id}>
                        <span class="absolute bottom-0 right-0  animate animate-bounce text-16.78px text-red">
                          {$loading.value.msg}
                        </span>
                      </Show>
                    </div>
                  </div>
                </div>
              );
            }}
          </For>
        </section>
        {!$conditions().is_tp22 && (
          <span class="flex !min-w-full items-end justify-end !self-end">
            {$conditions().items_length >= $conditions().max_elements
              ? "Max Elements Number Reached"
              : `${$conditions().items_length} / ${$conditions().max_elements} ${many_submissions.name}s`}
          </span>
        )}
      </Show>
    </main>
  );
}
